import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import Headers from '../../tutor/Header';
import Loader from '../../common/Loader';
import NavigationBar from '../../tutor/Navigation';
import { PATH } from '../../../../utils/Constants';
import {
    getEducatorFileUpload,
    getPreviousStudentList,
    getStudentChatList,
    getAllStudentList,
    getEducatorFileDownload,
    getUnreadPreviousUserList,
} from '../../../action/educator/AppointmentAction';
import store from '../../../../sessionStorage';
import { clearChatMessages } from '../../../action/ChatAction';
import {
    onCustomReadMessage,
    onCustomSendMessage,
    onTyping,
    onReadMessage,
    onChatOpened,
} from '../../../action/SocketActions';
import { showNotification } from '../../../action/NotificationAction';
import { RESPONSE_CONSTANT } from '../../../../utils/ResponseConstant';
import pdfImg from '../../../../utils/images/pdfpng.svg';
// import profileImg from "../../../../utils/images/profileImg.png";
import StaticImage from '../../../../utils/images/imagepng.svg';
import { customStyles, validateSearchNameInput } from '../../../../utils/Utility';
import Badge from '@mui/material/Badge';
import { getChatMessageHistory } from '../../../action/student/AppointmentAction';
import LanguageContext, { LanguageProvider } from '../../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

class MessageScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNav: false,
            selectedStudent: null,
            studentList: [],
            isEducatorLoading: false,
            textMessage: '',
            chatImage: [],
            uploadedImages: [],
            receiverId: '',
            messages: [],
            isImageUploaded: true,
            studentChatList: [],
            previousStudentList: [],
            selectedOption: null,
            IsSelected: false,
            searchValue: '',
            searchValueAll: '',
            searchValueNotRead: '',
            autoScrollToBottom: true,
            isAPICall: false,
            isScrollHeight: 0,
            isFile: false,
            isLoading: false,
            fileUrl: null,
            drafts: {},
            isStudentSelected: false,
            activeTab: 'all',
            unreadEducatorList: [],
            typingIndicator: {},
            lastMessage: {},
            displayLastMessage: [],
            searchResultsEmpty: false,
            blmToken: '',
            userBfId: '',
            isChatOpen: false,
            readReceiptCache: {},
            threadLastOpenedAt: {},
        };
        this.fileInputRef = React.createRef();
        this.chatContainerRef = React.createRef();
    }

    getReadCacheKey(message) {
        if (!message) return '';

        const sender =
            message.senderUserId ?? message.senderId ?? message.userId ?? message.fromUserId ?? '';
        const receiver =
            message.receiverUserId ??
            message.receiverId ??
            message.recipientId ??
            message.toUserId ??
            '';

        if (message.messageId !== undefined && message.messageId !== null && message.messageId !== '') {
            return `id:${String(message.messageId)}`;
        }

        if (message.fileId) {
            return `file:${String(sender)}:${String(receiver)}:${String(message.fileId)}`;
        }

        const textBody = (message.message || message.textMessage || '').trim();
        const created = message.createdTime || message.createdAt || '';
        return `sig:${String(sender)}:${String(receiver)}:${String(created)}:${textBody}`;
    }

    //componentDidMount
    componentDidMount() {
        // Initialize lists
        this.getPreviousStudentList();
        this.getAllStudentList(store.get('userSession').levelThree.id);
        this.getUnreadPreviousUserList();
        this.fetchLatestMessages();

        // Cache current BloomIfAI user id for later comparisons
        const currentUserId = store.get('bloomIfAI_id');
        if (currentUserId) {
            this.setState({ userBfId: currentUserId });
        }
    }

    fetchLatestMessages = () => {
        const values = {
            pageNumber: 1,
            itemsPerPage: 100,
        };
        this.props.getChatMessageHistory(values, (response) => {
            if (response && response.status === 'success') {
                const messages = response.response.messages;
                const lastMessages = [];
                messages.forEach((msg) => {
                    const senderName = msg.me ? 'You:' : '';
                    const messageText = msg.fileId
                        ? msg.fileType === 'pdf'
                            ? 'File'
                            : 'Image'
                        : msg.message;
                    const messageObject = {
                        name: senderName,
                        message: messageText,
                        receiverId: msg.receiverUserId,
                        senderId: msg.senderUserId,
                        // userBfId: store.get("bloomIfAI_id"),
                    };
                    lastMessages.push(messageObject);
                });
                this.setState({ displayLastMessage: lastMessages });
            }
        });
    };

    //componentDidUpdate
    componentDidUpdate(prevProps) {
        const { chatMessagesList, socketUnreadCount } = this.props;
        const { previousStudentList, receiverId, isAPICall, isScrollHeight } = this.state;

        const currentUserId =
            this.state.userBfId ||
            store.get('bloomIfAI_id') ||
            (store.get('userSession') && store.get('userSession').id);

        const chatOpenedMessages = Array.isArray(this.props.chatOpenedMessages)
            ? this.props.chatOpenedMessages
            : [];

        const chatOpenedReadUpdated =
            this.props.readStatus === true &&
            (prevProps.readStatus !== this.props.readStatus ||
                prevProps.senderUserId !== this.props.senderUserId ||
                prevProps.receiverUserId !== this.props.receiverUserId ||
                prevProps.chatOpenedTimestamp !== this.props.chatOpenedTimestamp ||
                prevProps.chatOpenedMessages !== this.props.chatOpenedMessages);

        if (chatOpenedReadUpdated) {
            const openedByUserId = this.props.senderUserId;
            const openedForUserId = this.props.receiverUserId;
            const isCurrentThreadOpened = String(openedByUserId) === String(receiverId);
            const isOpenedForCurrentUser =
                openedForUserId === undefined ||
                openedForUserId === null ||
                String(openedForUserId) === String(currentUserId);

            const readMessageIds = new Set(
                chatOpenedMessages
                    .filter((msg) => msg && msg.read === true && msg.messageId !== undefined)
                    .map((msg) => String(msg.messageId))
            );

            const hasMessageIdOverlap =
                readMessageIds.size > 0 &&
                (this.state.studentChatList || []).some(
                    (msg) =>
                        msg &&
                        msg.messageId !== undefined &&
                        readMessageIds.has(String(msg.messageId))
                );

            if ((isCurrentThreadOpened && isOpenedForCurrentUser) || hasMessageIdOverlap) {
                this.setState((prevState) => {
                    let hasAnyChange = false;
                    let hasCacheChange = false;
                    let hasThreadOpenChange = false;
                    const nextReadReceiptCache = { ...(prevState.readReceiptCache || {}) };
                    const nextThreadLastOpenedAt = { ...(prevState.threadLastOpenedAt || {}) };
                    const openTimestamp = this.props.chatOpenedTimestamp || Date.now();

                    if (openedByUserId !== undefined && openedByUserId !== null) {
                        const threadKey = String(openedByUserId);
                        const previousOpenTs = Number(nextThreadLastOpenedAt[threadKey] || 0);
                        const nextOpenTs = Number(openTimestamp || Date.now());
                        if (!previousOpenTs || nextOpenTs >= previousOpenTs) {
                            nextThreadLastOpenedAt[threadKey] = nextOpenTs;
                            hasThreadOpenChange = true;
                        }
                    }

                    const nextStudentChatList = (prevState.studentChatList || []).map((msg) => {
                        if (!msg) {
                            return msg;
                        }

                        const msgSender = msg.senderUserId ?? msg.senderId;
                        const msgReceiver =
                            msg.receiverUserId ?? msg.recipientId ?? msg.receiverId;
                        const msgId =
                            msg.messageId !== undefined && msg.messageId !== null
                                ? String(msg.messageId)
                                : null;

                        const shouldMarkReadById = msgId ? readMessageIds.has(msgId) : false;
                        const shouldMarkReadByUserPair =
                            readMessageIds.size === 0 &&
                            String(msgSender) === String(currentUserId) &&
                            String(msgReceiver) === String(openedByUserId);
                        const shouldMarkRead = shouldMarkReadById || shouldMarkReadByUserPair;

                        if (!shouldMarkRead) {
                            return msg;
                        }

                        const cacheKey = this.getReadCacheKey(msg);
                        if (cacheKey && !nextReadReceiptCache[cacheKey]) {
                            nextReadReceiptCache[cacheKey] = true;
                            hasCacheChange = true;
                        }

                        if (msg.read === true || msg.readStatus === true) {
                            return msg;
                        }

                        hasAnyChange = true;
                        return {
                            ...msg,
                            read: true,
                            readStatus: true,
                        };
                    });

                    if (isCurrentThreadOpened && isOpenedForCurrentUser) {
                        (prevState.messages || []).forEach((msg) => {
                            if (!msg) return;

                            const msgSender = msg.senderUserId ?? msg.senderId;
                            const msgReceiver = msg.receiverUserId ?? msg.receiverId ?? msg.recipientId;
                            const shouldCacheAsRead =
                                String(msgSender) === String(currentUserId) &&
                                String(msgReceiver) === String(openedByUserId);

                            if (!shouldCacheAsRead) return;

                            const cacheKey = this.getReadCacheKey(msg);
                            if (cacheKey && !nextReadReceiptCache[cacheKey]) {
                                nextReadReceiptCache[cacheKey] = true;
                                hasCacheChange = true;
                            }
                        });
                    }

                    if (!hasAnyChange && !hasCacheChange && !hasThreadOpenChange) {
                        return null;
                    }

                    return {
                        studentChatList: nextStudentChatList,
                        readReceiptCache: nextReadReceiptCache,
                        threadLastOpenedAt: nextThreadLastOpenedAt,
                    };
                });
            }
        }

        // Check preconditions
        if (!Array.isArray(previousStudentList) || previousStudentList.length === 0) {
            return;
        }

        if (
            !prevProps.chatMessagesList ||
            chatMessagesList.length <= prevProps.chatMessagesList.length
        ) {
            return;
        }

        // New message arrived
        const latestMessage = chatMessagesList[chatMessagesList.length - 1];
        if (!latestMessage) {
            return;
        }

        const { senderUserId, receiverUserId, message, fileId, fileType, createdTime } =
            latestMessage;

        // Determine active chat
        const activeChatId = receiverId === senderUserId ? receiverUserId : senderUserId;

        // Determine chat open status
        const selectedChat = JSON.parse(sessionStorage.getItem('selectedStudentChat') || 'null');

        const isChatOpen = selectedChat && receiverId === selectedChat.id;

        // Format message preview
        const latestText =
            message || (fileId ? (fileType === 'pdf' ? '📄 PDF File' : '🖼️ Image File') : '');

        const latestType = fileId ? (fileType === 'pdf' ? 'PDF' : 'Image') : 'Text';

        // Identify current user once for later checks
        // If this latest socket message is an echo of a message
        // we already added optimistically to local `messages`,
        // drop the local copy to avoid showing it twice.
        if (senderUserId === currentUserId) {
            this.setState((prevState) => {
                const idx = prevState.messages.findIndex((m) => {
                    if (!m) return false;
                    const sameSender = m.senderUserId === senderUserId;
                    const sameReceiver = m.receiverUserId === receiverUserId;
                    const sameFile = (m.fileId || null) === (fileId || null);
                    const sameText = (m.message || '').trim() === (latestText || '').trim();
                    return sameSender && sameReceiver && sameFile && sameText;
                });

                if (idx === -1) return null;

                const nextMessages = prevState.messages.slice();
                nextMessages.splice(idx, 1);
                return { messages: nextMessages };
            });
        }

        // READ EVENT
        if (isChatOpen && senderUserId === selectedChat?.id) {
            const messageReadPayload = {
                senderId: selectedChat?.id,
                receiverId: latestMessage.receiverUserId,
            };

            this.props.onCustomReadMessage(messageReadPayload);

            const senderId = store.get('bloomIfAI_id');

            this.props.onChatOpened({
                senderId,
                receiverId: this.state.receiverId,
            });
        }
        // Update student list
        const updatedList = previousStudentList.map((student) => {
            const isSender = student.id === senderUserId;
            const isSelected = isChatOpen && student.id === selectedChat?.id;

            let updatedCount = student.unreadCount || 0;

            // Backend unread
            if (socketUnreadCount && Array.isArray(socketUnreadCount.unReadCountDetails)) {
                const unreadEntry = socketUnreadCount.unReadCountDetails.find(
                    (entry) => entry.id === student.id
                );

                if (unreadEntry) {
                    updatedCount = unreadEntry.unReadCount;
                }
            }

            // Local increment
            if (isSender && !isSelected) {
                updatedCount += 1;
            }

            if (student.id === activeChatId) {
                return {
                    ...student,
                    latestMessage: latestText,
                    latestMessageType: latestType,
                    unreadCount: isChatOpen ? 0 : updatedCount,
                    lastMessageBy: senderUserId,
                    readStatus: isChatOpen,
                    createdTime: createdTime || new Date().toISOString(),
                };
            } else {
                return {
                    ...student,
                    latestMessage: student.latestMessage || '',
                    latestMessageType: student.latestMessageType || 'Text',
                    unreadCount: student.unreadCount || 0,
                    lastMessageBy: student.lastMessageBy || '',
                    readStatus: student.readStatus || false,
                    createdTime: student.createdTime || new Date().toISOString(),
                };
            }

            // return student;
        });

        // Move sender to top
        const senderIndex = updatedList.findIndex((student) => student.id === senderUserId);

        if (senderIndex !== -1) {
            const [senderStudent] = updatedList.splice(senderIndex, 1);
            updatedList.unshift(senderStudent);
        }

        // Update last-message preview list used in the UI's
        // previous users panel so that both incoming and
        // outgoing messages refresh the label, even after
        // an idle period.
        const otherUserId = senderUserId === currentUserId ? receiverUserId : senderUserId;
        const labelName = senderUserId === currentUserId ? 'You:' : '';

        const lastMessagePreview = {
            name: labelName,
            message: latestText,
            receiverId: otherUserId,
            senderId: senderUserId,
        };

        const filteredLastMessages = this.state.displayLastMessage.filter(
            (m) =>
                String(m.receiverId) !== String(otherUserId) &&
                String(m.senderId) !== String(otherUserId)
        );

        this.setState(
            {
                previousStudentList: updatedList,
                displayLastMessage: [lastMessagePreview, ...filteredLastMessages],
            },
            () => {
                const chatContainer = this.chatContainerRef?.current;

                if (isAPICall && chatContainer) {
                    chatContainer.scrollTop = chatContainer.scrollHeight - isScrollHeight;
                } else if (this.autoScrollToBottom) {
                    this.scrollToBottom();
                }
            }
        );
    }

    // scrollToBottom
    scrollToBottom = () => {
        const chatCotainer = this.chatContainerRef.current;
        if (chatCotainer) {
            chatCotainer.scrollTop = chatCotainer.scrollHeight;
        }
    };

    //handleScroll
    handleScroll = () => {
        const chatCotainer = this.chatContainerRef.current;
        const { scrollTop, scrollHeight, clientHeight } = chatCotainer;
        const enableScroll = Math.abs(scrollHeight - scrollTop - clientHeight) < 1;
        if (enableScroll) {
            this.autoScrollToBottom = true;
        } else {
            this.autoScrollToBottom = false;
        }
        if (scrollTop === 0) {
            if (this.props.chatLastPage > this.props.currentChatPage) {
                this.props.callChatAPI();
                this.setState({ isAPICall: true, isScrollHeight: scrollHeight });
            }
        } else {
            this.setState({ isAPICall: false });
        }
    };

    autoScrollToBottom = true;

    //handleFileUpload
    handleFileUpload = (event) => {
        const files = event.target.files;
        if (!files.length) {
            return;
        }
        const MAX_TOTAL_SIZE = 52428800; // 50MB
        const MAX_SINGLE_FILE_SIZE = 10485760; // 10MB

        let newChatImage = [...this.state.chatImage];
        let uploadedImages = [...this.state.uploadedImages];
        let totalUploadedSize = this.state.totalUploadedSize || 0;
        let newUploadSize = 0;
        const fileReaders = [];
        let isValid = true;
        const validFiles = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (
                file.type === 'image/png' ||
                file.type === 'image/jpeg' ||
                file.type === 'image/jpg' ||
                file.type === 'application/pdf'
            ) {
                if (file.size <= MAX_SINGLE_FILE_SIZE) {
                    newUploadSize += file.size;
                    if (totalUploadedSize + newUploadSize > MAX_TOTAL_SIZE) {
                        isValid = false;
                        this.setState({ isImageUploaded: false });
                        this.props.showNotification(
                            RESPONSE_CONSTANT.MEDIA_TOTAL_SIZE_EXCEEDED,
                            RESPONSE_CONSTANT.WARNING
                        );
                        return;
                    }
                    validFiles.push(file);
                } else {
                    isValid = false;
                    this.setState({ isImageUploaded: false });
                    this.props.showNotification(
                        RESPONSE_CONSTANT.MEDIA_FILE_SIZE,
                        RESPONSE_CONSTANT.WARNING
                    );
                    return;
                }
            } else {
                isValid = false;
                this.setState({ isImageUploaded: false });
                this.props.showNotification(
                    RESPONSE_CONSTANT.UPLOAD_ONLY_IMAGE,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
        }

        validFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                newChatImage.push(reader.result);
                uploadedImages.push(file);
                this.setState({
                    chatImage: [...newChatImage],
                    uploadedImages: [...uploadedImages],
                    totalUploadedSize: totalUploadedSize + newUploadSize,
                });
            };
            reader.readAsDataURL(file);
            fileReaders.push(reader);
        });

        if (isValid) {
            this.setState({ isImageUploaded: true });
        } else {
            this.setState({ isImageUploaded: false });
        }
    };

    //sendMessageClicked
    sendMessageClicked = () => {
        const { textMessage, uploadedImages, receiverId, studentList } = this.state;

        const totalImageSize = uploadedImages.reduce((total, file) => total + file.size, 0);
        if (totalImageSize > 50 * 1024 * 1024) {
            this.props.showNotification(
                RESPONSE_CONSTANT.MEDIA_TOTAL_SIZE_EXCEEDED,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }

        if (textMessage.trim() === '' && uploadedImages.length === 0) {
            return;
        }

        const moveStudentToTop = () => {
            const student = studentList.find((s) => s.id === receiverId);
            if (!student) return;
            this.setState((prevState) => ({
                previousStudentList: [
                    student,
                    ...prevState.previousStudentList.filter((s) => s.id !== receiverId),
                ],
            }));
        };

        const updateLastMessagePreview = (label) => {
            if (!receiverId) return;

            const currentUserId =
                this.state.userBfId ||
                store.get('bloomIfAI_id') ||
                (store.get('userSession') && store.get('userSession').id);

            const messageObject = {
                name: 'You:',
                message: label,
                receiverId,
                senderId: currentUserId,
            };

            this.setState((prevState) => {
                const filtered = prevState.displayLastMessage.filter(
                    (m) =>
                        String(m.receiverId) !== String(receiverId) &&
                        String(m.senderId) !== String(receiverId)
                );
                return {
                    displayLastMessage: [messageObject, ...filtered],
                };
            });
        };

        // TEXT MESSAGE
        // Always send text through the text-message channel.
        // File messages below are sent without duplicating this text.
        if (textMessage.trim() !== '') {
            // Restore original minimal payload shape so backend
            // custom chat routing receives exactly the expected
            // fields (textMessage, fileId, havingImage, receiverId).
            const payload = {
                textMessage: textMessage.trim(),
                fileId: null,
                havingImage: 0,
                receiverId,
            };

            // Clear current input & attachments before sending
            this.resetMessage();

            // Emit over custom chat socket. In some cases (for example,
            // after a long idle period) the realtime socket stream may
            // no longer push the new message back to Redux, so after the
            // optimistic callback we explicitly refresh the chat history
            // via API to ensure the just-sent message appears in the UI.
            this.props.onCustomSendMessage(payload, (message) => {
                const currentUserId = this.state.userBfId || store.get('bloomIfAI_id');
                const messageWithTime = {
                    ...message,
                    // ensure chat renderer sees the body as `message`
                    message: message.message || message.textMessage || textMessage.trim(),
                    createdTime: message.createdTime || new Date().toISOString(),
                    // ensure it passes the chat filter
                    senderUserId: currentUserId,
                    receiverUserId: receiverId,
                };

                this.setState(
                    (prevState) => ({
                        messages: [...prevState.messages, messageWithTime],
                    }),
                    () => {
                        if (this.autoScrollToBottom) {
                            this.scrollToBottom();
                        }
                    }
                );

                moveStudentToTop();
                updateLastMessagePreview(textMessage.trim());
            });
        }

        // FILE MESSAGE(S)
        if (uploadedImages.length > 0) {
            const formData = new FormData();
            uploadedImages.forEach((file) => {
                formData.append('multipartFiles', file);
            });
            formData.append('receiverUserId', receiverId);

            this.resetMessage();
            this.props.getEducatorFileUpload(formData, (response) => {
                if (
                    response &&
                    (response.status === RESPONSE_CONSTANT.SUCCESS ||
                        response.code === RESPONSE_CONSTANT.SUCCESS_CODE ||
                        response.code === 200)
                ) {
                    const uploadedImageUrl = response.response;
                    const messagePayload = {
                        textMessage: undefined,
                        fileId: uploadedImageUrl,
                        havingImage: uploadedImageUrl ? 1 : 0,
                        receiverId,
                    };

                    const currentUserId = this.state.userBfId || store.get('bloomIfAI_id');
                    const messageWithTime = {
                        ...messagePayload,
                        // normalise text body to `message` for renderer
                        message:
                            messagePayload.message ||
                            messagePayload.textMessage ||
                            '',
                        createdTime: new Date().toISOString(),
                        senderUserId: currentUserId,
                        receiverUserId: receiverId,
                        read: false,
                        readStatus: false,
                    };

                    this.setState(
                        (prevState) => ({
                            messages: [...prevState.messages, messageWithTime],
                        }),
                        () => {
                            if (this.autoScrollToBottom) {
                                this.scrollToBottom();
                            }
                        }
                    );

                    moveStudentToTop();

                    // Update preview label locally so the first
                    // image/file is reflected immediately under the
                    // user in the previous users list.
                    const firstFile = uploadedImages[0];
                    const isPdf = firstFile && firstFile.type === 'application/pdf';
                    updateLastMessagePreview(isPdf ? 'File' : 'Image');
                }
            });
        }
    };

    getUnreadPreviousUserList = (searchValue = '') => {
        const values = {
            search: searchValue,
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getUnreadPreviousUserList(values, (result) => {
            if (result) {
                this.setState({ unreadEducatorList: result.response.data });
            }
        });
    };

    //getPreviousStudentList
    getPreviousStudentList = (searchValue = '') => {
        this.setState({ isEducatorLoading: true });
        const values = {
            search: searchValue,
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getPreviousStudentList(values, (result) => {
            this.setState({ isEducatorLoading: false });
            if (result) {
                this.setState({
                    previousStudentList: result.response.data,
                    searchResultsEmpty: result.response.data.length === 0,
                });
            }
        });
    };

    //getAllStudentList
    getAllStudentList(id) {
        this.setState({ isEducatorLoading: true });
        const values = {
            search: '',
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getAllStudentList(id, values, (result) => {
            this.setState({ isEducatorLoading: false });
            if (result) {
                this.setState({
                    studentList: result.response.data,
                });
            }
        });
    }

    //getStudentChatList
    getStudentChatList(id) {
        this.setState({ isLoading: true });
        const values = {
            search: '',
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getStudentChatList(id, values, (result) => {
            this.setState({ isLoading: false });
            if (result) {
                this.setState({
                    studentChatList: result.response.messages,
                    // clear optimistic local messages once fresh
                    // history is loaded to avoid ordering issues
                    // or duplicates after idle.
                    messages: [],
                });
                this.scrollToBottom();
            }
        });
    }

    //handleSearchUser
    handleSearchUser = (e) => {
        const searchValue = e.target.value;
        if (validateSearchNameInput(searchValue)) {
            if (this.state.activeTab === 'all') {
                this.setState({ searchValueAll: searchValue }, () => {
                    this.getPreviousStudentList(searchValue);
                });
            } else if (this.state.activeTab === 'not-read') {
                this.setState({ searchValueNotRead: searchValue }, () => {
                    this.getUnreadPreviousUserList(searchValue);
                });
            }
        }
    };

    //handleFileDownload
    handleFileDownload = (fileId) => {
        this.props.getEducatorFileDownload(fileId, null, (response) => {
            if (response && response.code === 200) {
                window.open(response.response, '_blank');
            } else {
                this.props.showNotification(response.message, 'error');
            }
        });
    };

    handleMenuOpen = () => {
        if (this.state.activeTab === 'all') {
            this.setState({ searchValueAll: '' }, () => {
                this.getPreviousStudentList();
            });
        } else if (this.state.activeTab === 'not-read') {
            this.setState({ searchValueNotRead: '' }, () => {
                this.getUnreadPreviousUserList();
            });
        }
    };

    handleTabSwitch = (tab) => {
        this.setState(
            {
                activeTab: tab,
                searchValueAll: '',
                searchValueNotRead: '',
                searchValue: '',
            },
            () => {
                if (tab === 'all') {
                    this.getPreviousStudentList();
                } else if (tab === 'not-read') {
                    this.getUnreadPreviousUserList();
                }
            }
        );
    };

    //handleChange
    handleChange = async (selectedOption) => {
        const searchValue = selectedOption?.value || '';
        const selectedStudent = this.state.studentList.find(
            (student) => student.id === searchValue
        );
        let newPreviousStudentList = [...this.state.previousStudentList];
        if (
            selectedStudent &&
            !newPreviousStudentList.some((student) => student.id === selectedStudent.id)
        ) {
            newPreviousStudentList.push(selectedStudent);
        }
        const studentDisplayName = selectedStudent ? `${selectedStudent.name}` : null;
        const newState = {
            selectedStudent: studentDisplayName,
            receiverId: selectedStudent ? selectedStudent.id : null,
            IsSelected: !!selectedStudent,
            searchValue: '',
            isFile: false,
            previousStudentList: newPreviousStudentList,
        };
        if (this.state.receiverId) {
            const currentDraft = {
                textMessage: this.state.textMessage,
            };
            if (currentDraft.textMessage.trim() !== '') {
                sessionStorage.setItem(
                    `draft_${this.state.receiverId}`,
                    JSON.stringify(currentDraft)
                );
            } else {
                sessionStorage.removeItem(`draft_${this.state.receiverId}`);
            }
        }
        this.setState(newState, async () => {
            if (selectedStudent) {
                this.clearAllFiles();
                this.getStudentChatList(selectedStudent.id);
                const savedDraft = sessionStorage.getItem(`draft_${selectedStudent.id}`);
                if (savedDraft) {
                    const { textMessage } = JSON.parse(savedDraft);
                    this.setState({
                        textMessage: textMessage || '',
                    });
                }
            }
        });
    };

    //selectStudent
    selectStudent = async (student) => {
        this.props.clearChatMessages();

        // Save current draft BEFORE switching
        if (this.state.receiverId) {
            const currentDraft = {
                textMessage: this.state.textMessage,
            };

            if (currentDraft.textMessage.trim() !== '') {
                sessionStorage.setItem(
                    `draft_${this.state.receiverId}`,
                    JSON.stringify(currentDraft)
                );
            } else {
                sessionStorage.removeItem(`draft_${this.state.receiverId}`);
            }
        }

        // 🔥 Restore old behavior (needed for your componentDidUpdate)
        sessionStorage.setItem(
            'selectedStudentChat',
            JSON.stringify({
                id: student.id,
                name: student.name,
                role: student.role,
            })
        );

        const isStudentInList = this.state.previousStudentList.some((s) => s.id === student.id);

        this.setState(
            (prevState) => ({
                previousStudentList: !isStudentInList
                    ? [...prevState.previousStudentList, student]
                    : prevState.previousStudentList,
                selectedStudent: student.name,
                receiverId: student.id,
                textMessage: '',
                searchValue: '',
                isFile: false,
                isStudentSelected: true,
                threadLastOpenedAt: {
                    ...(prevState.threadLastOpenedAt || {}),
                    [String(student.id)]: Date.now(),
                },
            }),
            async () => {
                this.clearAllFiles();
                this.getStudentChatList(student.id);

                const savedDraft = sessionStorage.getItem(`draft_${student.id}`);
                if (savedDraft) {
                    const { textMessage } = JSON.parse(savedDraft);
                    this.setState({
                        textMessage: textMessage || '',
                    });
                }
            }
        );
    };

    handleSelectInputChange = (inputValue, { action }) => {
        const allowedCharacters = /^[a-zA-Z0-9\s]*$/;
        if (action === 'input-change') {
            if (allowedCharacters.test(inputValue)) {
                return inputValue;
            } else {
                return '';
            }
        }
        return inputValue;
    };

    //handleInputChange
    handleInputChange = (e) => {
        const message = e.target.value;
        this.setState({ textMessage: message });
        if (message.trim() !== '' && !this.state.isTyping) {
            this.setState({ isTyping: true });
            const typingPayload = {
                senderId: this.props.userId,
                receiverId: this.state.receiverId,
                typing: 'true',
            };
            this.props.onTyping(typingPayload);
        }
        if (message.trim() === '' && this.state.isTyping) {
            this.setState({ isTyping: false });
            const typingPayload = {
                senderId: this.props.userId,
                receiverId: this.state.receiverId,
                typing: 'false',
            };

            this.props.onTyping(typingPayload);
        }
        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
        }
        this.typingTimeout = setTimeout(() => {
            if (this.state.isTyping) {
                this.setState({ isTyping: false });
                const typingPayload = {
                    senderId: this.props.userId,
                    receiverId: this.state.receiverId,
                    typing: 'false',
                };
                this.props.onTyping(typingPayload);
            }
        }, 5000);
    };

    //handleFileButtonClick
    handleFileButtonClick = () => {
        this.setState((prevState) => ({
            isFile: !prevState.isFile,
        }));
    };

    //handleBackspaceClick
    handleBackspaceClick = () => {
        this.setState({ selectedStudent: null });
    };

    //isLoading
    isLoading() {
        this.setState({ isLoading: !this.state.isLoading });
    }

    //onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    //clearAllFiles
    clearAllFiles = () => {
        this.setState(
            {
                textMessage: '',
                chatImage: [],
                uploadedImages: [],
            },
            () => {
                this.fileInputRef.current.value = '';
                if (this.state.receiverId) {
                    sessionStorage.removeItem(`draft_${this.state.receiverId}`);
                }
            }
        );
    };

    //removeFile
    removeFile = (index) => {
        this.setState(
            (prevState) => {
                const updatedChatImage = [...prevState.chatImage];
                const updatedUploadedImages = [...prevState.uploadedImages];
                updatedChatImage.splice(index, 1);
                updatedUploadedImages.splice(index, 1);
                return {
                    chatImage: updatedChatImage,
                    uploadedImages: updatedUploadedImages,
                };
            },
            () => {
                this.fileInputRef.current.value = '';
            }
        );
    };

    //resetMessage
    resetMessage = () => {
        this.setState(
            {
                textMessage: '',
                uploadedImages: [],
                chatImage: [],
                totalUploadedSize: 0,
                isImageUploaded: false,
            },
            () => {
                this.fileInputRef.current.value = '';
            }
        );
    };

    //customOptionLabel
    customOptionLabel = ({ label }) => (
        <div className="overflow-hidden truncate" title={label}>
            {label}
        </div>
    );

    getInitials(name) {
        if (!name) return '';
        const nameParts = name.trim().split(' ');
        const first = nameParts[0]?.charAt(0).toUpperCase() || '';
        const second = nameParts[1]?.charAt(0).toUpperCase() || '';
        return first + second;
    }

    formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
        return `${hours}:${minutes} ${ampm}`;
    }

    render() {
        const {
            chatMessagesList,
            socketUnreadCount,
            // userSession,
            // typingIndicator,
        } = this.props;
        const {
            receiverId,
            chatImage,
            studentList,
            // searchResultsEmpty,
            activeTab,
            searchValueAll,
            searchValueNotRead,
        } = this.state;
        let options = studentList.map((student) => ({
            value: student.id,
            label: `${student.name}`,
        }));

        // Normalize socket messages: some may use `textMessage` instead of
        // `message` for the text body. `chatMessagesList` already contains
        // flat message objects, so we only need to ensure `message` is set.
        const normalizedSocketMessages = chatMessagesList.map((raw) => {
            if (!raw) return raw;

            const normalizedText =
                raw.message !== undefined && raw.message !== null && raw.message !== ''
                    ? raw.message
                    : raw.textMessage;

            return {
                ...raw,
                message: normalizedText,
            };
        });

        const chatOpenedReadMessageIds = new Set(
            (Array.isArray(this.props.chatOpenedMessages) ? this.props.chatOpenedMessages : [])
                .filter((msg) => msg && msg.read === true && msg.messageId !== undefined)
                .map((msg) => String(msg.messageId))
        );

        const currentUserIdForRead =
            this.state.userBfId ||
            store.get('bloomIfAI_id') ||
            (store.get('userSession') && store.get('userSession').id);

        const readReceiptCache = this.state.readReceiptCache || {};
        const threadLastOpenedAt = this.state.threadLastOpenedAt || {};

        const toBooleanFlag = (value) => value === true || value === 'true' || value === 1;

        const getMessageReadFlag = (message) => {
            if (!message) return false;

            const cacheKey = this.getReadCacheKey(message);
            if (cacheKey && readReceiptCache[cacheKey] === true) {
                return true;
            }

            if (
                message.messageId !== undefined &&
                message.messageId !== null &&
                chatOpenedReadMessageIds.has(String(message.messageId))
            ) {
                return true;
            }

            if (message.read !== undefined && message.read !== null && toBooleanFlag(message.read)) {
                return true;
            }

            if (
                message.readStatus !== undefined &&
                message.readStatus !== null &&
                toBooleanFlag(message.readStatus)
            ) {
                return true;
            }

            if (
                message.message_read !== undefined &&
                message.message_read !== null &&
                toBooleanFlag(message.message_read)
            ) {
                return true;
            }

            // Fallback for file-message flows where chat-open receipts
            // arrive without per-message ids. If the recipient opened this
            // active thread, mark my outgoing messages in this thread as read.
            const openedByUserId = this.props.senderUserId;
            const openedForUserId = this.props.receiverUserId;
            const isActiveThreadOpenedByReceiver =
                this.props.readStatus === true &&
                String(openedByUserId) === String(receiverId) &&
                (openedForUserId === undefined ||
                    openedForUserId === null ||
                    String(openedForUserId) === String(currentUserIdForRead));

            if (
                isActiveThreadOpenedByReceiver &&
                String(message.senderUserId) === String(currentUserIdForRead) &&
                String(message.receiverUserId) === String(receiverId)
            ) {
                return true;
            }

            const perThreadOpenedAt = Number(threadLastOpenedAt[String(receiverId)] || 0);
            const messageTimeRaw = message.createdTime || message.createdAt || message.timestamp;
            const messageTime = messageTimeRaw ? new Date(messageTimeRaw).getTime() : 0;

            if (
                perThreadOpenedAt > 0 &&
                messageTime > 0 &&
                messageTime <= perThreadOpenedAt &&
                String(message.senderUserId) === String(currentUserIdForRead) &&
                String(message.receiverUserId) === String(receiverId)
            ) {
                return true;
            }

            return false;
        };

        const filteredMessagesFromList = normalizedSocketMessages.filter((message) => {
            if (!message) return false;

            return (
                (message.senderUserId === receiverId || message.receiverUserId === receiverId) &&
                ((message.message && message.message.trim() !== '') || message.fileId)
            );
        });

        // Combine:
        //  - history from API (`studentChatList`)
        //  - live socket messages (`filteredMessagesFromList`)
        //  - optimistic local messages (`messages`)
        //
        // De-duplication below prevents duplicates when socket/history echoes arrive.
        const optimisticThreadMessages = (this.state.messages || []).filter((msg) => {
            if (!msg) return false;
            return (
                String(msg.senderUserId) === String(currentUserIdForRead) &&
                String(msg.receiverUserId) === String(receiverId) &&
                ((msg.message && String(msg.message).trim() !== '') || msg.fileId)
            );
        });

        const combinedMessages = [
            ...this.state.studentChatList,
            ...filteredMessagesFromList,
            ...optimisticThreadMessages,
        ];

        // De‑duplicate messages coming from history + socket.
        // Prefer messageId when present; otherwise fall back to a
        // composite signature so the same image/file isn't shown twice.
        const getMessageKey = (msg) => {
            if (!msg) return 'null';
            return this.getReadCacheKey(msg) || 'null';
        };

        const uniqueMessages = combinedMessages.reduce((acc, message) => {
            const key = getMessageKey(message);
            const existingIndex = acc.findIndex((m) => getMessageKey(m) === key);

            if (existingIndex === -1) {
                acc.push(message);
                return acc;
            }

            const existing = acc[existingIndex] || {};
            const incoming = message || {};

            acc[existingIndex] = {
                ...existing,
                ...incoming,
                message: incoming.message || existing.message,
                fileId: incoming.fileId || existing.fileId,
                fileType: incoming.fileType || existing.fileType,
                read: toBooleanFlag(existing.read) || toBooleanFlag(incoming.read),
                readStatus:
                    toBooleanFlag(existing.readStatus) || toBooleanFlag(incoming.readStatus),
                message_read:
                    toBooleanFlag(existing.message_read) || toBooleanFlag(incoming.message_read),
            };

            return acc;
        }, []);
        const sortedMessages = uniqueMessages.sort((a, b) => {
            return new Date(a.createdTime) - new Date(b.createdTime);
        });
        const selectedStudent = studentList.find((student) => student.id === this.state.receiverId);

        return (
            <div className="fixed top-0 left-0 flex w-full h-full">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${this.state.mobileNav ? 'block' : 'hidden'}`}
                ></div>
                <NavigationBar
                    nav={true}
                    {...this.props}
                    active={PATH.IM_PHYSICIAN.MESSAGES}
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-col flex-grow h-screen overflow-hidden">
                    <Headers
                        {...this.props}
                        title={this.props.t('messages')}
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="w-full contents">
                        <div className="flex justify-end w-full px-3 py-2 bg-UIBackground">
                            <Select
                                onChange={this.handleChange}
                                onMenuOpen={this.handleMenuOpen}
                                name="form-field-name"
                                isSearchable={true}
                                isClearable={true}
                                options={options}
                                placeholder={this.props.t('selectOrEnterName')}
                                noOptionsMessage={() => {
                                    return this.props.t('noRecordFound');
                                }}
                                className="w-1/3 text-white"
                                styles={customStyles}
                                value={this.state.selectedOption}
                                formatOptionLabel={this.customOptionLabel}
                                onInputChange={this.handleSelectInputChange}
                            />
                        </div>
                        <div className="flex flex-row w-full h-full overflow-hidden bg-UIBackground">
                            <div
                                className={`bg-card w-[100%] md:w-[30%] m-5 rounded-lg ${this.state.selectedStudent ? 'sm:block hidden' : 'block'}`}
                            >
                                <header className="px-5">
                                    <div className="py-3">
                                        <div className="relative mt-2">
                                            <input
                                                type="text"
                                                onChange={this.handleSearchUser}
                                                value={
                                                    activeTab === 'all'
                                                        ? searchValueAll
                                                        : searchValueNotRead
                                                }
                                                className="w-full py-1.5 px-4 bg-schedule rounded-lg text-white"
                                                placeholder={this.props.t('search')}
                                                autoComplete="off"
                                                maxLength={50}
                                            />
                                            <i className="fas fa-search absolute right-3 top-1/2 transform -translate-y-1/2 text-[#10DACE]"></i>
                                        </div>
                                    </div>
                                </header>
                                <div className="w-full px-4">
                                    <div className="flex w-full h-[42px] p-1 gap-1 rounded-lg bg-[#181B22]">
                                        <button
                                            className={`flex-1 flex items-center justify-center py-2 rounded-lg text-white transition-all duration-150 ${
                                                this.state.activeTab === 'all'
                                                    ? 'bg-[#543CC2]'
                                                    : 'text-gray-400'
                                            }`}
                                            onClick={() => {
                                                this.setState({ activeTab: 'all' }, () => {
                                                    this.setState({ searchValueAll: '' });
                                                    this.getPreviousStudentList();
                                                });
                                            }}
                                        >
                                            {this.props.t('all')}
                                        </button>
                                        <button
                                            className={`flex-1 flex items-center justify-center py-2 rounded-lg transition-all duration-150 ${
                                                this.state.activeTab === 'not-read'
                                                    ? 'bg-[#543CC2] text-white'
                                                    : 'text-gray-400'
                                            }`}
                                            onClick={() => {
                                                this.setState({ activeTab: 'not-read' }, () => {
                                                    this.setState({ searchValueNotRead: '' });
                                                    this.getUnreadPreviousUserList();
                                                });
                                            }}
                                        >
                                            {this.props.t('notRead')}
                                        </button>
                                    </div>
                                </div>

                                {this.state.activeTab === 'not-read' &&
                                this.state.unreadEducatorList.length === 0 ? (
                                    <div className="flex items-center justify-center text-white mt-[35%]">
                                        {this.props.t('noUnreadChatsFound')}
                                    </div>
                                ) : (
                                    <div className="overflow-y-auto h-[50vh] lg:h-[49vh] xl:h-[49vh] 2xl:h-[59vh]">
                                        {this.state.activeTab === 'all' &&
                                            (this.state.previousStudentList.length === 0 ? (
                                                <div className="flex items-center justify-center text-white mt-[35%]">
                                                    {this.props.t('noUsersFound')}
                                                </div>
                                            ) : (
                                                this.state.previousStudentList.map(
                                                    (student, index) => {
                                                        const savedDraft = sessionStorage.getItem(
                                                            `draft_${student.id}`
                                                        );
                                                        let draftExists = false;
                                                        if (savedDraft) {
                                                            const parsedDraft =
                                                                JSON.parse(savedDraft);
                                                            draftExists =
                                                                parsedDraft.textMessage &&
                                                                parsedDraft.textMessage.trim() !==
                                                                    '';
                                                        }
                                                        return (
                                                            <div
                                                                key={student.id || index}
                                                                className={`relative flex items-center my-5 gap-x-4 px-5 cursor-pointer py-2 ${
                                                                    student.id === receiverId
                                                                        ? 'bg-[#34373E]'
                                                                        : 'hover:bg-[#34373E]'
                                                                }`}
                                                                onClick={() => {
                                                                    this.props.onChatOpened({
                                                                        senderId:
                                                                            store.get(
                                                                                'bloomIfAI_id'
                                                                            ),
                                                                        receiverId: student.id,
                                                                    });
                                                                    const tempStudent = {
                                                                        id: student.id,
                                                                        name: student.name,
                                                                        role: student.role,
                                                                    };
                                                                    sessionStorage.setItem(
                                                                        'selectedStudentChat',
                                                                        JSON.stringify(tempStudent)
                                                                    );
                                                                    this.setState({
                                                                        isChatOpen: true,
                                                                    });
                                                                    this.selectStudent(student);
                                                                }}
                                                            >
                                                                {/* {student.profileImage ? (
                                <img
                                  className="w-[50px] h-[50px] rounded-full bg-gray-50"
                                  src={student.profileImage}
                                  alt=""
                                />
                              ) : (
                                <img
                                  className="w-[50px] h-[50px] rounded-full bg-gray-50"
                                  src={profileImg}
                                  alt=""
                                />
                              )} */}
                                                                <div className="w-[50px] h-[50px] rounded-full bg-black flex items-center justify-center text-white text-md font-medium">
                                                                    {this.getInitials(student.name)}
                                                                </div>
                                                                <div className="flex items-center flex-grow ">
                                                                    <div className="flex flex-col">
                                                                        <h2
                                                                            className="text-base font-medium lg:text-lg md:text-white md:w-28 whitespace-nowrap"
                                                                            title={student.name}
                                                                        >
                                                                            {student.name.length >
                                                                            10
                                                                                ? student.name.slice(
                                                                                      0,
                                                                                      10
                                                                                  ) + '...'
                                                                                : student.name}
                                                                        </h2>
                                                                        <small
                                                                            className={`text-sm md:text-base w-50 whitespace-nowrap ${
                                                                                student.unReadCount >
                                                                                0
                                                                                    ? 'text-white'
                                                                                    : 'text-[#B9B9B9]'
                                                                            }`}
                                                                        >
                                                                            {this.props
                                                                                .typingIndicatorShown
                                                                                ?.typingIndicator &&
                                                                            (this.props
                                                                                .typingIndicatorShown
                                                                                .receiverUserId ===
                                                                                student.id ||
                                                                                this.props
                                                                                    .typingIndicatorShown
                                                                                    .senderUserId ===
                                                                                    student.id) ? (
                                                                                <span className="text-green-500">
                                                                                    {student.name}{' '}
                                                                                    {this.props.t(
                                                                                        'typing'
                                                                                    )}
                                                                                </span>
                                                                            ) : draftExists ? (
                                                                                <span className="text-green-500">
                                                                                    {this.props.t(
                                                                                        'draft'
                                                                                    )}
                                                                                </span>
                                                                            ) : (
                                                                                this.state.displayLastMessage
                                                                                    .filter(
                                                                                        (fil) =>
                                                                                            fil.receiverId ===
                                                                                                student.id ||
                                                                                            fil.senderId ===
                                                                                                student.id
                                                                                    )
                                                                                    .map(
                                                                                        (
                                                                                            item,
                                                                                            messageIndex
                                                                                        ) => (
                                                                                            <p
                                                                                                key={
                                                                                                    messageIndex
                                                                                                }
                                                                                                className="flex max-w-full gap-1"
                                                                                            >
                                                                                                <span className="font-medium">
                                                                                                    {
                                                                                                        item.name
                                                                                                    }
                                                                                                </span>
                                                                                                <span
                                                                                                    className="truncate overflow-hidden whitespace-nowrap max-w-[150px]"
                                                                                                    title={
                                                                                                        item.message
                                                                                                    }
                                                                                                >
                                                                                                    {
                                                                                                        item.message
                                                                                                    }
                                                                                                </span>
                                                                                            </p>
                                                                                        )
                                                                                    )
                                                                            )}
                                                                        </small>
                                                                        {/* <h2 className="text-sm md:text-white w-50 whitespace-nowrap">
                                    {draftExists && (
                                      <span className="ml-5 text-green-500">
                                        Draft
                                      </span>
                                    )}
                                  </h2> */}
                                                                    </div>
                                                                    <div className="absolute flex flex-col items-end -translate-y-2/3 right-4 top-1/2 gap-y-2">
                                                                        <small className="text-sm text-white md:text-sm w-max whitespace-nowrap">
                                                                            {
                                                                                student.previousMessage
                                                                            }
                                                                        </small>
                                                                        <Badge
                                                                            className="mt-2 text-white"
                                                                            badgeContent={(() => {
                                                                                // Do not show a badge on the
                                                                                // currently open chat row.
                                                                                if (
                                                                                    student.id ===
                                                                                    this.state
                                                                                        .receiverId
                                                                                ) {
                                                                                    return null;
                                                                                }

                                                                                let unreadCount =
                                                                                    null;

                                                                                // Primary source: socket-driven
                                                                                // unreadCountDetails from Redux.
                                                                                if (
                                                                                    socketUnreadCount?.unReadCountDetails &&
                                                                                    Array.isArray(
                                                                                        socketUnreadCount.unReadCountDetails
                                                                                    )
                                                                                ) {
                                                                                    const foundUnread =
                                                                                        socketUnreadCount.unReadCountDetails.find(
                                                                                            (
                                                                                                detail
                                                                                            ) =>
                                                                                                String(
                                                                                                    detail.id
                                                                                                ) ===
                                                                                                String(
                                                                                                    student.id
                                                                                                )
                                                                                        );

                                                                                    if (
                                                                                        foundUnread &&
                                                                                        typeof foundUnread.unReadCount ===
                                                                                            'number'
                                                                                    ) {
                                                                                        unreadCount =
                                                                                            foundUnread.unReadCount;
                                                                                    }
                                                                                }

                                                                                // Fallback: use unread count
                                                                                // coming directly from the
                                                                                // previous-student list API
                                                                                // when socket details are not
                                                                                // yet available for this user.
                                                                                if (
                                                                                    (unreadCount ===
                                                                                        null ||
                                                                                        unreadCount ===
                                                                                            undefined) &&
                                                                                    typeof student.unReadCount ===
                                                                                        'number'
                                                                                ) {
                                                                                    unreadCount =
                                                                                        student.unReadCount;
                                                                                }

                                                                                // Normalize: hide zero / falsy
                                                                                // counts so the badge is shown
                                                                                // only when there is at least
                                                                                // one unread message.
                                                                                if (
                                                                                    typeof unreadCount ===
                                                                                        'number' &&
                                                                                    unreadCount > 0
                                                                                ) {
                                                                                    return unreadCount;
                                                                                }

                                                                                return null;
                                                                            })()}
                                                                            sx={{
                                                                                '& .MuiBadge-badge':
                                                                                    {
                                                                                        backgroundColor:
                                                                                            '#10DACE',
                                                                                        color: 'black',
                                                                                    },
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                )
                                            ))}
                                        {this.state.activeTab === 'not-read' &&
                                            this.state.unreadEducatorList.map((student, index) => {
                                                const savedDraft = sessionStorage.getItem(
                                                    `draft_${student.id}`
                                                );
                                                let draftExists = false;
                                                if (savedDraft) {
                                                    const parsedDraft = JSON.parse(savedDraft);
                                                    draftExists =
                                                        parsedDraft.textMessage &&
                                                        parsedDraft.textMessage.trim() !== '';
                                                }
                                                return (
                                                    <div
                                                        key={student.id || index}
                                                        className={`relative flex items-center my-5 gap-x-4 px-5 cursor-pointer py-2 ${
                                                            student.id === receiverId
                                                                ? 'bg-[#34373E]'
                                                                : 'hover:bg-[#34373E]'
                                                        }`}
                                                        onClick={() => this.selectStudent(student)}
                                                    >
                                                        {/* {student.profileImage ? (
                              <img
                                className="w-[50px] h-[50px] rounded-full bg-gray-50"
                                src={student.profileImage}
                                alt=""
                              />
                            ) : (
                              <img
                                className="w-[50px] h-[50px] rounded-full bg-gray-50"
                                src={profileImg}
                                alt=""
                              />
                            )} */}
                                                        <div className="w-[50px] h-[50px] rounded-full bg-black flex items-center justify-center text-white text-md font-medium">
                                                            {this.getInitials(student.name)}
                                                        </div>
                                                        <div className="flex items-center flex-grow">
                                                            <div className="flex flex-col">
                                                                <h2
                                                                    className="overflow-hidden text-base font-medium lg:text-lg md:text-white md:w-28 whitespace-nowrap text-ellipsis"
                                                                    title={student.name}
                                                                >
                                                                    {student.name.length > 10
                                                                        ? student.name.slice(
                                                                              0,
                                                                              10
                                                                          ) + '...'
                                                                        : student.name}
                                                                </h2>
                                                                <small
                                                                    className={`text-sm md:text-base w-50 whitespace-nowrap ${
                                                                        student.unReadCount > 0
                                                                            ? 'text-white'
                                                                            : 'text-[#B9B9B9]'
                                                                    }`}
                                                                >
                                                                    {this.props.typingIndicatorShown
                                                                        ?.typingIndicator &&
                                                                    (this.props.typingIndicatorShown
                                                                        .receiverUserId ===
                                                                        student.id ||
                                                                        this.props
                                                                            .typingIndicatorShown
                                                                            .senderUserId ===
                                                                            student.id) ? (
                                                                        <span className="text-green-500">
                                                                            {student.name}{' '}
                                                                            {this.props.t('typing')}
                                                                        </span>
                                                                    ) : (
                                                                        this.state.displayLastMessage
                                                                            .filter(
                                                                                (fil) =>
                                                                                    fil.receiverId ===
                                                                                        student.id ||
                                                                                    fil.senderId ===
                                                                                        student.id
                                                                            )
                                                                            .map(
                                                                                (
                                                                                    item,
                                                                                    messageIndex
                                                                                ) => (
                                                                                    <p
                                                                                        key={
                                                                                            messageIndex
                                                                                        }
                                                                                        className="flex max-w-full gap-1"
                                                                                    >
                                                                                        <span className="font-medium">
                                                                                            {
                                                                                                item.name
                                                                                            }
                                                                                        </span>
                                                                                        <span
                                                                                            className="truncate overflow-hidden whitespace-nowrap max-w-[150px]"
                                                                                            title={
                                                                                                item.message
                                                                                            }
                                                                                        >
                                                                                            {
                                                                                                item.message
                                                                                            }
                                                                                        </span>
                                                                                    </p>
                                                                                )
                                                                            )
                                                                    )}
                                                                </small>
                                                                <h2 className="text-sm md:text-white w-50 whitespace-nowrap">
                                                                    {draftExists && (
                                                                        <span className="ml-5 text-green-500">
                                                                            {this.props.t('draft')}
                                                                        </span>
                                                                    )}
                                                                </h2>
                                                            </div>
                                                            <div className="absolute flex flex-col items-end -translate-y-2/3 right-4 top-1/2 gap-y-2">
                                                                <small className="text-sm text-white md:text-sm w-max whitespace-nowrap">
                                                                    {student.previousMessage}
                                                                </small>
                                                                <Badge
                                                                    className="mt-2 text-white"
                                                                    badgeContent={(() => {
                                                                        if (
                                                                            student.id ===
                                                                            this.state.receiverId
                                                                        ) {
                                                                            return null;
                                                                        }
                                                                        if (
                                                                            socketUnreadCount?.senderUserId
                                                                        ) {
                                                                            const foundUnreadCount =
                                                                                socketUnreadCount?.unReadCountDetails?.find(
                                                                                    (countDetail) =>
                                                                                        countDetail.id ===
                                                                                        student.id
                                                                                );
                                                                            return foundUnreadCount?.unReadCount;
                                                                        }
                                                                        return student.unReadCount;
                                                                    })()}
                                                                    sx={{
                                                                        '& .MuiBadge-badge': {
                                                                            backgroundColor:
                                                                                '#10DACE',
                                                                            color: 'black',
                                                                        },
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                )}
                            </div>
                            <>
                                {this.state.selectedStudent ? (
                                    <div className="w-[100%] md:w-[70%] flex flex-col bg-card rounded-lg my-5 mx-3">
                                        <header className="flex items-center justify-between p-4">
                                            <div className="flex items-center">
                                                <button
                                                    className="p-2 mr-2 rounded-full sm:hidden"
                                                    onClick={this.handleBackspaceClick}
                                                    aria-label="Back to Previous Student"
                                                >
                                                    <i className="fas fa-arrow-left"></i>
                                                </button>
                                                <div className="flex items-center">
                                                    {/* {selectedStudent?.profileImage ? (
                            <img
                              className="w-10 h-10 mr-2 rounded-full"
                              src={selectedStudent.profileImage}
                              alt="Profile"
                            />
                          ) : (
                            <img
                              className="w-10 h-10 mr-2 rounded-full"
                              src={profileImg}
                              alt="Profile"
                            />
                          )} */}
                                                    <div className="w-[40px] h-[40px] rounded-full bg-black flex items-center justify-center text-white text-sm">
                                                        {this.getInitials(selectedStudent?.name)}
                                                    </div>
                                                    &nbsp;
                                                    <h1
                                                        className="font-semibold text-white lg:text-2xl md:text-base"
                                                        title={this.state.selectedStudent}
                                                    >
                                                        {this.state.selectedStudent ||
                                                            this.props.t('teamMemberName')}
                                                    </h1>
                                                </div>
                                            </div>
                                            <div
                                                className="flex items-center pr-5 text-white cursor-pointer"
                                                onClick={this.handleFileButtonClick}
                                            >
                                                <svg
                                                    width="25"
                                                    height="26"
                                                    viewBox="0 0 25 26"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M12.8438 13.1564L10.2708 15.7293C8.84376 17.1564 8.84376 19.4584 10.2708 20.8855C11.6979 22.3126 14 22.3126 15.4271 20.8855L19.4792 16.8334C22.323 13.9897 22.323 9.36468 19.4792 6.52092C16.6354 3.67717 12.0104 3.67717 9.16668 6.52092L4.75 10.9376C2.3125 13.3751 2.3125 17.3334 4.75 19.7814"
                                                        stroke="white"
                                                        strokeWidth="1.5625"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>

                                                {this.state.isFile ? this.props.t('chat') : ''}
                                            </div>
                                        </header>
                                        {this.state.isLoading ? (
                                            <Loader />
                                        ) : (
                                            <div
                                                className="flex flex-col flex-1 p-4 overflow-y-auto bg-collaboratortable"
                                                onScroll={() => this.handleScroll()}
                                                ref={this.chatContainerRef}
                                            >
                                                <div className="mt-auto">
                                                    {sortedMessages
                                                        .filter(
                                                            (message) =>
                                                                !this.state.isFile || message.fileId
                                                        )
                                                        .map((message, index) => {
                                                            const isReceiver =
                                                                message.senderUserId ===
                                                                this.state.receiverId;
                                                            const isMyMessage = !isReceiver;

                                                            const senderName = isReceiver
                                                                ? selectedStudent?.name ||
                                                                  this.props.t('student')
                                                                : this.props.t('you');

                                                            const time = this.formatTimestamp(
                                                                message.createdTime
                                                            );

                                                            /* Keep tick status tied to each message payload to avoid
                                                               cross-chat read-state bleed when switching users. */
                                                            let status = null;

                                                            if (isMyMessage) {
                                                                const isRead =
                                                                    getMessageReadFlag(message);
                                                                const isDelivered =
                                                                    message.delivered === true;

                                                                let tickColor = '#B9B9B9'; // default unread/delivered

                                                                if (isRead) {
                                                                    tickColor = '#10DACE'; // blue seen
                                                                } else if (isDelivered) {
                                                                    tickColor = '#B9B9B9'; // grey delivered
                                                                }

                                                                status = (
                                                                    <svg
                                                                        width="18"
                                                                        height="12"
                                                                        viewBox="0 0 18 12"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M1 6.9L4.143 10.5L12 1.5M17 1.563L8.428 10.563L8 10"
                                                                            stroke={tickColor}
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                );
                                                            }

                                                            return (
                                                                <div
                                                                    key={index}
                                                                    className={`flex mb-4 ${isReceiver ? '' : 'justify-end'}`}
                                                                >
                                                                    {/* Receiver Avatar */}
                                                                    {isReceiver && (
                                                                        <div className="w-[30px] h-[30px] rounded-full bg-black flex items-center justify-center text-white text-sm">
                                                                            {this.getInitials(
                                                                                selectedStudent.name
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    &nbsp;
                                                                    <div className="flex flex-col">
                                                                        {/* Name + Time + Status */}
                                                                        <div className="flex items-center mb-1">
                                                                            <span className="flex items-center text-sm text-white">
                                                                                {senderName} &nbsp;
                                                                                <svg
                                                                                    width="4"
                                                                                    height="4"
                                                                                    viewBox="0 0 4 4"
                                                                                    fill="none"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                >
                                                                                    <circle
                                                                                        cx="2"
                                                                                        cy="2"
                                                                                        r="2"
                                                                                        fill="#B9B9B9"
                                                                                    />
                                                                                </svg>
                                                                            </span>

                                                                            <div className="flex items-center ml-2">
                                                                                <span className="mr-1 text-xs text-gray-500">
                                                                                    {time}
                                                                                </span>
                                                                                {status}
                                                                            </div>
                                                                        </div>

                                                                        {/* Text Message */}
                                                                        {message.message && (
                                                                            <div
                                                                                className={`${
                                                                                    isReceiver
                                                                                        ? 'bg-black text-white'
                                                                                        : 'bg-[#34373E] text-white'
                                                                                } rounded-md p-2`}
                                                                                style={{
                                                                                    maxWidth:
                                                                                        '50ch',
                                                                                    wordWrap:
                                                                                        'break-word',
                                                                                }}
                                                                            >
                                                                                <p className="text-sm">
                                                                                    {message.message
                                                                                        .split(/\n/)
                                                                                        .map(
                                                                                            (
                                                                                                line,
                                                                                                i
                                                                                            ) => (
                                                                                                <React.Fragment
                                                                                                    key={
                                                                                                        i
                                                                                                    }
                                                                                                >
                                                                                                    {
                                                                                                        line
                                                                                                    }
                                                                                                    <br />
                                                                                                </React.Fragment>
                                                                                            )
                                                                                        )}
                                                                                </p>
                                                                            </div>
                                                                        )}

                                                                        {/* File Message */}
                                                                        {message.fileId && (
                                                                            <a
                                                                                href={
                                                                                    this.state
                                                                                        .fileUrl
                                                                                }
                                                                                onClick={() =>
                                                                                    this.handleFileDownload(
                                                                                        message.fileId
                                                                                    )
                                                                                }
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                <img
                                                                                    src={
                                                                                        message.fileType ===
                                                                                        'pdf'
                                                                                            ? pdfImg
                                                                                            : StaticImage
                                                                                    }
                                                                                    alt="Uploaded"
                                                                                    onError={(
                                                                                        e
                                                                                    ) => {
                                                                                        if (
                                                                                            message.fileType !==
                                                                                            'pdf'
                                                                                        )
                                                                                            e.target.src =
                                                                                                pdfImg;
                                                                                    }}
                                                                                    className="object-cover w-20 h-20 mt-2 cursor-pointer"
                                                                                />
                                                                            </a>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    {this.props.typingIndicatorShown
                                                        ?.typingIndicator &&
                                                        (this.state.receiverId ===
                                                            this.props.typingIndicatorShown
                                                                .receiverUserId ||
                                                            this.state.receiverId ===
                                                                this.props.typingIndicatorShown
                                                                    .senderUserId) && (
                                                            <div className="flex justify-start mb-4">
                                                                <div className="flex items-center space-x-1">
                                                                    <div className="w-2 h-2 bg-gray-500 rounded-full animate-typing [animation-delay:0ms]"></div>
                                                                    <div className="w-2 h-2 bg-gray-500 rounded-full animate-typing [animation-delay:200ms]"></div>
                                                                    <div className="w-2 h-2 bg-gray-500 rounded-full animate-typing [animation-delay:400ms]"></div>
                                                                </div>
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                        )}
                                        <div className="w-full rounded-lg bg-collaboratortable">
                                            <div
                                                className="p-4 overflow-x-auto"
                                                style={{ maxHeight: '400px' }}
                                            >
                                                <div className="flex space-x-4">
                                                    {chatImage.length > 0 &&
                                                        chatImage.map((image, index) => (
                                                            <div
                                                                key={index}
                                                                className="relative flex-shrink-0 border border-[#34373E]"
                                                            >
                                                                {image.includes(
                                                                    'data:application/pdf'
                                                                ) ? (
                                                                    <div
                                                                        className="pdf-icon"
                                                                        style={{
                                                                            color: '#c30909',
                                                                            width: '5rem',
                                                                            height: '5rem',
                                                                            borderRadius: '0.5rem',
                                                                            fontSize: '50px',
                                                                            display: 'flex',
                                                                            justifyContent:
                                                                                'center',
                                                                            alignItems: 'center',
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-file-pdf"></i>
                                                                    </div>
                                                                ) : (
                                                                    <img
                                                                        src={image}
                                                                        className="w-20 h-20 rounded"
                                                                        alt=""
                                                                    />
                                                                )}
                                                                <span
                                                                    className="absolute cursor-pointer fas fa-times-circle text-red"
                                                                    style={{
                                                                        top: '-10px',
                                                                        right: '-10px',
                                                                    }}
                                                                    onClick={() => {
                                                                        this.removeFile(
                                                                            index,
                                                                            'image'
                                                                        );
                                                                    }}
                                                                ></span>
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                            <div className="relative flex items-center px-3 m-2 rounded-full bg-dateselect">
                                                <div className="relative flex items-center flex-grow">
                                                    <textarea
                                                        className="w-full p-3 text-justify text-white bg-transparent rounded-full resize-none focus:outline-none"
                                                        placeholder={this.props.t('writeAMessage')}
                                                        value={this.state.textMessage}
                                                        onChange={this.handleInputChange}
                                                        onKeyPress={(e) => {
                                                            if (e.key === 'Enter' && !e.shiftKey) {
                                                                e.preventDefault();
                                                                this.sendMessageClicked();
                                                            }
                                                        }}
                                                        maxLength={255}
                                                        rows={1}
                                                    />
                                                </div>
                                                <div className="flex space-x-2">
                                                    <button
                                                        className="p-2 text-white rounded-full bg-collaboratortable"
                                                        onClick={() =>
                                                            this.fileInputRef.current.click()
                                                        }
                                                    >
                                                        <svg
                                                            width="19"
                                                            height="18"
                                                            viewBox="0 0 19 18"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M10.1534 9.1118L8.3123 10.9529C7.29114 11.974 7.29114 13.6213 8.3123 14.6424C9.33346 15.6636 10.9807 15.6636 12.0019 14.6424L14.9014 11.743C16.9362 9.7081 16.9362 6.39865 14.9014 4.36379C12.8665 2.32893 9.55707 2.32893 7.52221 4.36379L4.36184 7.52416C2.61767 9.26833 2.61767 12.1007 4.36184 13.8524"
                                                                stroke="white"
                                                                strokeWidth="1.11806"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </button>
                                                    <button
                                                        className="p-2 text-white rounded-full bg-[#755FDC]"
                                                        onClick={this.sendMessageClicked}
                                                    >
                                                        <svg
                                                            width="19"
                                                            height="18"
                                                            viewBox="0 0 19 18"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M5.66373 4.76624L11.9919 2.65684C14.8318 1.71022 16.3747 3.26059 15.4355 6.10045L13.3261 12.4286C11.9099 16.6847 9.58438 16.6847 8.16817 12.4286L7.54206 10.5503L5.66373 9.9242C1.40766 8.508 1.40766 6.1899 5.66373 4.76624Z"
                                                                stroke="white"
                                                                strokeWidth="1.11806"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M7.68457 10.2298L10.353 7.55396"
                                                                stroke="white"
                                                                strokeWidth="1.11806"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <input
                                                    type="file"
                                                    ref={this.fileInputRef}
                                                    className="hidden"
                                                    accept=".png, .jpeg, .jpg, .pdf"
                                                    onChange={this.handleFileUpload}
                                                    multiple
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="items-center justify-center hidden mx-3 my-5 text-white rounded-lg sm:block bg-card md:flex md:flex-1">
                                        {this.props.t('selectTeamMemberToStart')}
                                    </div>
                                )}
                            </>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

MessageScreen.propTypes = {
    getAllStudentList: PropTypes.func.isRequired,
    getEducatorFileUpload: PropTypes.func.isRequired,
    onCustomSendMessage: PropTypes.func.isRequired,
    showNotification: PropTypes.func.isRequired,
    chatMessagesList: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
    chatMessagesList: state.ChatReducerList.chatMessagesList,
    socketUnreadCount: {
        unReadCountDetails: state.UnreadReducerCount.unReadCountDetails,
        unReadMessageCount: state.UnreadReducerCount.unReadMessageCount,
        receiverUserId: state.UnreadReducerCount.receiverUserId,
        senderUserId: state.UnreadReducerCount.senderUserId,
        receiverUnReadMessageCount: state.UnreadReducerCount.receiverUnReadMessageCount,
    },
    typingIndicatorShown: {
        typingIndicator: state.ChatReducerList.typingIndicator,
        receiverUserId: state.ChatReducerList.receiverUserId,
        senderUserId: state.ChatReducerList.senderUserId,
    },
    OnMessageRead: state.ChatReducerList.message_read,
    latestMessages: state.latestMessageReducer.latestMessages,
    senderUserId: state.latestMessageReducer.senderUserId,
    receiverUserId: state.latestMessageReducer.receiverUserId,
    createdTime: state.latestMessageReducer.createdTime,
    readStatus: state.latestMessageReducer.readStatus,
    chatOpenedMessages: state.latestMessageReducer.messages,
    chatOpenedTimestamp: state.latestMessageReducer.timestamp,
});

const mapDispatchToProps = {
    getAllStudentList,
    getPreviousStudentList,
    getStudentChatList,
    getEducatorFileUpload,
    getEducatorFileDownload,
    getUnreadPreviousUserList,
    onCustomSendMessage,
    showNotification,
    clearChatMessages,
    onCustomReadMessage,
    onTyping,
    onReadMessage,
    getChatMessageHistory,
    onChatOpened,
};

const ConnectedMessageScreen = withLanguage(
    connect(mapStateToProps, mapDispatchToProps)(MessageScreen)
);

export default (props) => (
    <LanguageProvider>
        <ConnectedMessageScreen {...props} />
    </LanguageProvider>
);
